// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js??ref--4-1!./swiper.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("eef1c19e", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/swiper/css/swiper.css
// module id = 110
// module chunks = 1